import * as React from "react"
import { Box, Typography } from "@mui/material"

import { NotAllowedBlock } from "@components"


export default function scoringColumn() {
	return {
		name: "IADistance", label: "Scoring",
		options: {
			filter: false,
			customBodyRowRenderLite: (value) => <Box sx={{ textAlign: 'center' }}>
				{!!value && <Typography variant="body2"> {value} </Typography>}
				{!value && <NotAllowedBlock />}
			</Box>
		}
	}
}